import { createTheme } from '@mui/material/styles';
import tokens from './tokens';

const CUSTOM_VARIANTS = [
  'dialogTitle',
  'sectionTitle',
  'fieldLabel',
  'sectionLabel',
  'tableHeader',
  'tableCell',
  'subtitle',
  'statValue',
  'kpiValue',
  'unit',
];

const customVariantStyles = CUSTOM_VARIANTS.reduce((acc, name) => {
  const { fontSize, ...rest } = tokens.type[name];
  acc[name] = {
    fontFamily: tokens.fontFamily,
    fontSize: `${fontSize}px`,
    ...rest,
  };
  return acc;
}, {});

const variantMapping = CUSTOM_VARIANTS.reduce((acc, name) => {
  acc[name] = name === 'dialogTitle' ? 'h2' : 'span';
  return acc;
}, {});

const theme = createTheme({
  palette: {
    primary: { main: tokens.primary.main, dark: tokens.primary.dark },
    ft: tokens,
  },
  typography: {
    fontFamily: tokens.fontFamily,
    fontWeightRegular: tokens.fontWeights.regular,
    fontWeightMedium: tokens.fontWeights.medium,
    fontWeightBold: tokens.fontWeights.semibold,
    ...customVariantStyles,
  },
  components: {
    MuiTypography: {
      defaultProps: { variantMapping },
    },
  },
});

export default theme;
